import { ThemeProvider } from '@mui/material';
import React, { useState } from 'react';

import { themeCreator } from './base';

interface Props {
  children: React.ReactElement;
}

export const ThemeContext = React.createContext(
  (_themeName: string): void => {},
);

const ThemeProviderWrapper = (props: Props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const setThemeName = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    _setThemeName(themeName);
  };

  return (
    <ThemeContext.Provider value={setThemeName}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProviderWrapper;
